// api/user.ts
import type { LoginParam, UserInfo } from '@/types/user'

import request from '@/utils/request'

/**
 * 登录
 * @param data LoginParam
 * @returns token
 */
export const login = (data: LoginParam) => {
  console.log('登录获取token2')
  return request<string>({
    method: 'POST',
    url: '/user/login',
    data: { ...data }
  })
}

// 获取当前用户信息
export const getUserInfo = () => {
  console.log('获取用户信息2')
  return request<UserInfo>({
    method: 'GET',
    url: '/user/userinform'
  })
}

/**
 * 免费注册
 */
export const register = (data: {
  nickname: string
  username: string
  password: string
  email: string
  mobilephone?: string
}) => {
  return request<string>({
    method: 'POST',
    url: '/user/register',
    data
  })
}

/**
 * 发送验证码
 */
export const sendCode = (email: string) => {
  return request<string>({
    method: 'POST',
    url: '/user/send-code',
    data: { email }
  })
}

/**
 * 重置密码
 */
export const resetPassword = (data: { email: string; code: string; newPassword: string }) => {
  return request<string>({
    method: 'POST',
    url: '/user/reset-password',
    data
  })
}

/**
 * 退出登录
 */
export const logout = () => {
  return request<string>({
    method: 'POST',
    url: '/user/logout'
  })
}

/**
 * 用户列表（分页）
 */
export const getUserList = (params: { pageNum: number; pageSize: number; search?: string }) => {
  return request<any>({
    method: 'GET',
    url: '/user',
    params
  })
}

/**
 * 新增用户
 */
export const createUser = (data: any) => {
  return request<string>({
    method: 'POST',
    url: '/user',
    data
  })
}

/**
 * 更新用户
 */
export const updateUser = (data: any) => {
  return request<string>({
    method: 'PUT',
    url: '/user',
    data
  })
}

/**
 * 删除用户
 */
export const deleteUser = (id: number) => {
  return request<string>({
    method: 'DELETE',
    url: `/user/${id}`
  })
}
